module.exports = __webpack_public_path__ + "img/playMindWhite.2ac449a1.svg";